import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React from "react";
import Products from "./Products";
import Codes from "./Codes";
import Retry from "./Retry";
import NotFound from "./NotFound";
import HealthCheck from "./HealthCheck";
import OtherRedeem from "./OtherRedeem";
import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom";
import {VALIDATE_ROUTE, REDEEM_ROUTE, RETRY_ROUTE, NOT_FOUND_ROUTE, HEALTH_CHECK_ROUTE, OTHER_REDEEM_ROUTE } from './Constant';

function App() {
  return (
      <Router>
          <Switch>
              <Route exact path={VALIDATE_ROUTE + ":token"} component={Products}/>
              <Route exact path={REDEEM_ROUTE + ":token"} component={Codes}/>
              <Route exact path={RETRY_ROUTE + ":token"} component={Retry}/>
              <Route exact path={OTHER_REDEEM_ROUTE + ":token"} component={OtherRedeem}/>
              <Route exact path={HEALTH_CHECK_ROUTE} component={HealthCheck}/>
              <Route exact path={NOT_FOUND_ROUTE} component={NotFound}/>
              <Redirect to={NOT_FOUND_ROUTE}/>
          </Switch>
      </Router>
  );
}

export default App;